import { z } from "zod/v4";

export const emailFTZSchema = z
  .string()
  .email("bookingV3.docInternational.error.emailValidFTZ");
export const emailSchema = (
  isRequired = false,
  isFtz = false,
  emailValue = ""
) => {
  if (isRequired)
    return z
      .string()
      .nonempty("bookingV3.docInternational.error.emailMandatory")
      .email("bookingV3.docInternational.error.emailValid");
  if (isFtz || !isRequired)
    return !emailValue ? z.string().optional() : emailFTZSchema;
  return z.string().email("bookingV3.docInternational.error.emailValid");
};

export const idNumberSchema = (isRequired = false) => {
  if (isRequired)
    return z
      .string()
      .max(100)
      .nonempty("bookingV3.docInternational.error.idNumberMandatory");

  return z.string().max(100);
};
export const taxNumberSchema = (
  isRequired = false,
  isFTZ = false,
  taxNumberValue = "",
  max = 16,
  min = 15
) => {
  const isOptional = isFTZ || !isRequired;
  if (isRequired)
    return z
      .string()
      .nonempty("bookingV3.docInternational.error.taxNumberMandatory")
      .max(100);

  if (isOptional && taxNumberValue)
    return z
      .string()
      .min(min, { message: "bookingV3.docInternational.error.taxNumberMin" })
      .max(max);

  return z.string();
};
export const itemDetailSchema = z
  .string()
  .nonempty("bookingV3.docInternational.error.itemDetailMandatory");
export const quantitySchema = z
  .string()
  .nonempty("bookingV3.docInternational.error.quantityMandatory");
export const goodsPriceSchema = z
  .string()
  .nonempty("bookingV3.docInternational.error.goodsPriceMandatory");
